import angular from 'angular';
import quickProductFinderDetailModal from './quickProductFinderDetailModal';

export default angular
  .module('components.quickProductFinderDetailModal', [])
  .component('quickProductFinderDetailModal', quickProductFinderDetailModal)
  .name;
